import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './UpdateBanner.css';

/**
 * Persistent banner displayed at the top of the screen when the backend
 * indicates that this web app version is below the minimum required.
 *
 * The banner is driven by the `updateRequired` field returned in the
 * login response and stored in AuthContext.
 */
const UpdateBanner = () => {
  const { updateRequired, dismissUpdateBanner } = useAuth();

  if (!updateRequired) return null;

  return (
    <div className="update-banner" role="alert">
      <div className="update-banner-content">
        <span className="update-banner-icon">⚠️</span>
        <span className="update-banner-message">
          {updateRequired.message}
        </span>
        {updateRequired.deadline && (
          <span className="update-banner-deadline">
            Deadline: {updateRequired.deadline}
          </span>
        )}
        <button
          className="update-banner-action"
          onClick={() => window.location.reload()}
        >
          Refresh Now
        </button>
      </div>
      <button
        className="update-banner-dismiss"
        onClick={dismissUpdateBanner}
        aria-label="Dismiss update notice"
      >
        ✕
      </button>
    </div>
  );
};

export default UpdateBanner;
